import React from 'react';

import { Button, ButtonProps } from '../Button';

const EmptyState = ({
  heading,
  description,
  primaryAction,
  secondaryAction,
}: {
  heading: string;
  description?: string;
  primaryAction?: {
    label: string;
    onClick: () => void;
    variant: ButtonProps['variant'];
    leftIcon?: React.ReactNode;
    rightIcon?: React.ReactNode;
    isLoading?: boolean;
  };
  secondaryAction?: {
    label: string;
    onClick: () => void;
    variant: ButtonProps['variant'];
    leftIcon?: React.ReactNode;
    rightIcon?: React.ReactNode;
    isLoading?: boolean;
  };
}) => {
  return (
    <div className="py-3xl px-5xl flex flex-col gap-2xl items-center">
      <div className="flex flex-col gap-xs items-center text-center">
        <h3 className="txt-medium-bold text-text-primary">{heading}</h3>
        {description ? (
          <p className="txt-small-regular text-text-secondary">{description}</p>
        ) : null}
      </div>
      <div className="flex items-center gap-xl">
        {primaryAction ? (
          <Button
            size="sm"
            onClick={primaryAction.onClick}
            isLoading={primaryAction.isLoading}
            variant={primaryAction.variant}
          >
            {primaryAction.leftIcon}
            <span>{primaryAction.label}</span>
            {primaryAction.rightIcon}
          </Button>
        ) : null}
        {secondaryAction ? (
          <Button
            size="sm"
            variant={secondaryAction.variant}
            onClick={secondaryAction.onClick}
            isLoading={secondaryAction.isLoading}
          >
            {secondaryAction.leftIcon}
            {secondaryAction.label}
            {secondaryAction.rightIcon}
          </Button>
        ) : null}
      </div>
    </div>
  );
};

export { EmptyState };
